import { Route, Redirect } from 'react-router-dom';
import { getUserProfile } from '~/helpers/userProfile';

export const Route404 = ({ ...params }): JSX.Element => {
  const isLogged = !!localStorage.getItem('@diel:token');
  const profile = getUserProfile();
  const selectedRemoteControl = localStorage.getItem('choosePlataform') === '/controle-inteligente';
  const perUnitUnits = profile.permissions.PER_UNIT?.flatMap((x) => x.units) ?? [];
  const hasSingleUnitAccess = (profile.permissions.PER_CLIENT?.length ?? 0) === 0 && perUnitUnits.length === 1;

  function redirect() {
    if (isLogged) {
      if (profile.permissions.isPersonaII && selectedRemoteControl) {
        return <Redirect to="/controle-inteligente" />;
      }
      if (hasSingleUnitAccess) {
        return <Redirect to={`/analise/unidades/${perUnitUnits[0]}`} />;
      }
      return <Redirect to="/analise/unidades" />;
    }
    return <Redirect to="/login" />;
  }
  return (
    <Route
      {...params}
      render={redirect}
    />
  );
};
